module.exports = __webpack_public_path__ + "img/newPremium.0976df52.png";